import React from 'react';
import { graphql } from 'gatsby';
import { BuilderComponent } from '@builder.io/react';
import { Helmet } from 'react-helmet';

import '../builder-settings';
import Layout from '../layout/Layout';

const PageTemplate = ({ data }) => {
  const models = data?.allBuilderModels;
  const page = models.onePage?.content;

  return (
    <Layout>
      <Helmet>
        {/* <!-- Open Graph Meta Tags --> */}
        <meta property="og:type" content="website" />
        <meta property='og:title' content={page.data.title} />
        <meta property='og:description' content={page.data.description} />
        <meta property='og:image' content={page.data.socialsImage} />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name='twitter:title' content={page.data.title} />
        <meta name='twitter:description' content={page.data.description} />
        <meta name='twitter:image' content={page.data.socialsImage} />

      </Helmet>
      <BuilderComponent model="page" content={page} />
    </Layout>
  );
}

export default PageTemplate;

export const pageQuery = graphql`
  query ($path: String!) {
    allBuilderModels {
      onePage(
        target: { urlPath: $path }
        options: { cachebust: true }
      ) {
        content
      }
    }
  }
`;
